import { useEffect, useRef, useState } from "react";
import "./EmojiPicker.css";

const EMOJIS = [
  "😀", "😃", "😄", "😁", "😊", "🙂", "😉", "😍",
  "🥰", "😘", "😎", "🤩", "🥳", "😂", "🤣", "🥲",
  "😅", "😌", "🤔", "🫡", "🤗", "🤭", "😴", "😢",
  "😭", "😤", "😡", "🤯", "😱", "🙄", "😬", "🫠",
  "👍", "👎", "👏", "🙌", "🙏", "🤝", "💪", "🤞",
  "👌", "✌️", "👋", "❤️", "🧡", "💛", "💚", "💙",
  "💜", "🖤", "💔", "✨", "🔥", "🎉", "✅", "❌",
  "💡", "🚀", "🎯", "💯", "👀", "💬", "📌", "⚠️",
];

export default function EmojiPicker({ onSelect, disabled = false, compact = false }) {
  const [open, setOpen] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const handlePointerDown = (event) => {
      if (!pickerRef.current?.contains(event.target)) setOpen(false);
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.addEventListener("pointerdown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  return (
    <div className={`emoji-picker ${compact ? "compact" : ""}`} ref={pickerRef}>
      <button
        type="button"
        className={`emoji-picker-toggle ${open ? "active" : ""}`}
        onClick={() => setOpen((current) => !current)}
        disabled={disabled}
        title="Add emoji"
        aria-label="Add emoji"
        aria-expanded={open}
      >
        <span aria-hidden="true">☺</span>
      </button>
      {open && (
        <div className="emoji-picker-popover" role="dialog" aria-label="Choose an emoji">
          <div className="emoji-picker-grid">
            {EMOJIS.map((emoji, index) => (
              <button
                key={`${emoji}-${index}`}
                type="button"
                className="emoji-picker-option"
                onClick={() => onSelect(emoji)}
                aria-label={`Insert ${emoji}`}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}